import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { VariantChipsModule } from 'src/app/shared/shop/variant-chips/variant-chips.module';
import { ProductVariantsComponent } from './product-variants.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    VariantChipsModule
  ],
  exports: [ProductVariantsComponent],
  declarations: [ProductVariantsComponent]
})
export class ProductVariantsModule { }
